import React from 'react';

import { useSelector } from '#redux';

import { Background } from './Background';
import { CargaRumbo } from './CargaRumbo';

type AppBackgroundProps = {
  isLoading?: boolean;
};

export function AppBackground({ isLoading }: AppBackgroundProps) {
  const loadingText = useSelector(state => state.app.loadingText);
  const showLoading = isLoading || loadingText !== null;

  return (
    <>
      <Background />
      {/* Rumbo: la carga es el velero sobre el cielo del puerto. */}
      {showLoading && <CargaRumbo texto={loadingText} />}
    </>
  );
}
